export function getRandomImages(count: number): string[] {
  const LOCAL_IMAGES = [
    "/images/story-card/story.png",
    "/images/story-card/siro.png",
    "/images/story-card/siro-sakura.png",
    "/images/story-card/turu.png",
    "/images/story-card/gokayama.png",
    "/images/story-card/hasi.png",
    "/images/story-card/kyoto.png",
    "/images/story-card/kyoto2.png",
    "/images/story-card/kyoto3.png",
    "/images/story-card/aki.png",
    "/images/story-card/hanabi.png",
    "/images/story-card/natu.png",
    "/images/story-card/toyama-jyou.png",
    "/images/story-card/mado-2.png",
    "/images/story-card/torii.png",
    "/images/story-card/yu-shiro.png",
  ];
 
  const SPECIAL_IMAGE = "/images/story-card/god.png";

  if (count > LOCAL_IMAGES.length) {
    throw new Error("指定された画像数が上限を超えています。");
  }

  const imagePool = [...LOCAL_IMAGES];
  const selectedImages: string[] = [];

  for (let i = 0; i < count; i++) {
    const index = Math.floor(Math.random() * imagePool.length);
    selectedImages.push(imagePool.splice(index, 1)[0]);
  }

  const insertSpecial = Math.floor(Math.random() * 8192) === 0;
  if (insertSpecial) {
    const replaceIndex = Math.floor(Math.random() * selectedImages.length);
    selectedImages[replaceIndex] = SPECIAL_IMAGE;
  }

  return selectedImages;
}
